import React, { useState } from 'react';
import { absolutizeMediaUrl } from '../utils/url';

interface EmployeeAvatarProps {
  firstName?: string;
  lastName?: string;
  photoUrl?: string | null;
  size?: number;
  style?: React.CSSProperties;
}

const EmployeeAvatar: React.FC<EmployeeAvatarProps> = ({
  firstName = '',
  lastName = '',
  photoUrl,
  size = 36,
  style = {},
}) => {
  const [imageError, setImageError] = useState(false);
  const initials = `${firstName?.[0] || ''}${lastName?.[0] || ''}`.toUpperCase();
  const showImage = photoUrl && !imageError;

  // Foto: rund, ohne Foto: quadratisch mit abgerundeten Ecken
  const borderRadius = showImage ? size / 2 : Math.min(6, size * 0.2);

  const baseStyle: React.CSSProperties = {
    width: size,
    height: size,
    borderRadius,
    flexShrink: 0,
    ...style,
  };

  if (showImage) {
    return (
      <img
        src={absolutizeMediaUrl(photoUrl)}
        alt={`${firstName} ${lastName}`}
        style={{
          ...baseStyle,
          objectFit: 'cover',
        }}
        onError={() => setImageError(true)}
      />
    );
  }

  return (
    <div
      style={{
        ...baseStyle,
        background: '#0e7490',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: size * 0.4,
        fontWeight: 600,
      }}
    >
      {initials || '?'}
    </div>
  );
};

export default EmployeeAvatar;
